import React from 'react';
import Croppie from 'croppie';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paragraph from 'ui/Paragraph';
import DialogButtons from 'ui/dialog/Buttons';

import 'croppie/croppie.css';

const DEFAULT_OPTIONS = {
    width: 200,
    height: 200,
    type: 'circle',
};

function prepareOptions(options, defaultOptions = DEFAULT_OPTIONS) {
    const defaultNames = Object.keys(defaultOptions);
    return Object.keys(options)
        .filter(name => defaultNames.includes(name))
        .reduce(
            (newOptions, name) =>
                Object.assign({}, newOptions, { [name]: options[name] }),
            defaultOptions
        );
}

export default class CropEditor extends React.Component {
    constructor(props) {
        super(props);
        this.img = React.createRef();
    }
    componentWillReceiveProps(nextProps) {
        if (this.cropper && nextProps.src) {
            if (this.props.src !== nextProps.src) {
                this.cropper.bind(nextProps.src);
            }
        }
    }
    onCrop = () => {
        const { width, height, type } = this.getCropperOptions(this.props);
        this.cropper
            .result({
                type: 'blob',
                width,
                height,
                circle: type === 'circle',
            })
            .then(blob => this.props.onCrop(blob));
    };
    onEntered = () => {
        // Wait for image to load before initializing Croppie
        const img = this.img.current;
        if (!img || !img.src || !this.props.src) {
            console.error('Croppie: Source image missing');
            return;
        }

        const initializeCroppie = () => {
            const options = this.getCropperOptions(this.props);
            this.cropper = new Croppie(img, options);
            if (this.props.src) {
                this.cropper.bind(this.props.src);
            }
        };

        if (img.complete && img.naturalHeight !== 0) {
            // Image is already loaded
            initializeCroppie();
        } else {
            // Wait for image to load
            img.onload = initializeCroppie;
            img.onerror = () => {
                console.error('Croppie: Failed to load source image');
            };
        }
    };
    onExit = () => {
        this.cropper.destroy();
        this.cropper = null;
    };
    render() {
        const { open, onClose } = this.props;
        return (
            <Dialog
                open={open}
                onClose={onClose}
                TransitionProps={{
                    onEntered: this.onEntered,
                    onExit: this.onExit,
                }}
            >
                <DialogTitle>Adjust image</DialogTitle>
                <DialogContent>
                    <Paragraph>
                        Adjust the image to fit in the circle. You can use the
                        slider to crop the image or you can drag the image to
                        center it.
                    </Paragraph>
                    <img
                        ref={this.img}
                        src={this.props.src}
                        style={{ opacity: 0, width: '1px' }}
                        alt="Cropper"
                    />
                </DialogContent>
                <DialogActions>
                    <DialogButtons>
                        <DialogButtons.Secondary
                            onClick={onClose}
                            label="Cancel"
                        />
                        <DialogButtons.Primary
                            variant="contained"
                            onClick={this.onCrop}
                            label="Save"
                        />
                    </DialogButtons>
                </DialogActions>
            </Dialog>
        );
    }
    getCropperOptions(options) {
        const { width, height, type } = prepareOptions(options);
        return {
            viewport: {
                width,
                height,
                type,
            },
            boundary: {
                width,
                height,
            },
        };
    }
}
